export class EntraRestoreReportEntityRelationships {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "membershipsRestored",
            "baseName": "membershipsRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "membershipsDropped",
            "baseName": "membershipsDropped",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "ownersRestored",
            "baseName": "ownersRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "roleAssignmentsRestored",
            "baseName": "roleAssignmentsRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "licensesRestored",
            "baseName": "licensesRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "ownedObjectsRestored",
            "baseName": "ownedObjectsRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "membersRestored",
            "baseName": "membersRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "managersRestored",
            "baseName": "managersRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "directReportsRestored",
            "baseName": "directReportsRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "appRoleAssignmentsRestored",
            "baseName": "appRoleAssignmentsRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "appRoleAssigneesRestored",
            "baseName": "appRoleAssigneesRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "permissionsRestored",
            "baseName": "permissionsRestored",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportEntityRelationships.attributeTypeMap;
    }
    constructor() {
    }
}
